<template>
  <div class="login">
    <div class="login__close">
      <UtilityIconButton
        size="lg"
        variant="round"
        backgroundColor="#272b2f"
        highlightColor="rgba(255,255,255,0.7)"
        highlightBackgroundColor="#272b2f"
        content="Close"
        v-tippy="{ theme: 'statzon--white', placement: 'left', arrow: true, animation: 'scale' }"
        @click.native="resetSearch()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23 20.168l-8.185-8.187 8.185-8.174-2.832-2.807-8.182 8.179-8.176-8.179-2.81 2.81 8.186 8.196-8.186 8.184 2.81 2.81 8.203-8.192 8.18 8.192z"/></svg>
      </UtilityIconButton>
    </div>

    <div class="login__left">
      <div class="login__form">
        <AuthLogin
          v-if="$route.meta.step === 'login'"
          @loggedIn="userLoggedIn()"
        />

        <AuthForgot
          v-if="$route.meta.step === 'request' || $route.meta.step === 'reset'"
          @continued="userContinued()"
        />
      </div>
    </div>

    <div class="login__right">
      <h2>New here?</h2>
      <div class="spacer" />
      <p>Sign up for <span class="highlight--title">free</span> to access all<br />world level datasets!</p>

      <UtilityCtaButton
        icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M13 18v-4h-7v-4h7v-4l6 6-6 6zm-1-16c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12z"/></svg>'
        :round="true"
        color="blue"
        class="login__registerBtn"
        @click="goToRegister()"
      >
        Sign up
      </UtilityCtaButton>

      <div class="login__buffer" />
    </div>
  </div>
</template>

<script>
import AuthLogin from '@/components/auth/Login.vue'
import AuthForgot from '@/components/auth/Forgot.vue'
import UtilityIconButton from '@/components/utility/IconButton.vue'
import UtilityCtaButton from '@/components/utility/CtaButton.vue'

export default {
  components: {
    AuthLogin,
    AuthForgot,
    UtilityIconButton,
    UtilityCtaButton
  },
  metaInfo () {
    return {
      title: 'Login'
    }
  },
  computed: {
    incomingUrl () {
      return this.$store.getters['search/getIncomingUrl']
    },
    isAuthenticated () {
      return this.$store.getters['user/isAuthenticated']
    }
  },
  methods: {
    userLoggedIn () {
      setTimeout(function () {
        if (this.incomingUrl !== '') {
          let goUrl = this.incomingUrl
          this.$store.dispatch('search/resetState')
          this.$router.push(goUrl)
        } else {
          this.$store.dispatch('search/resetState')
          this.$router.push('/')
        }
      }.bind(this), 1000)
    },
    resetSearch () {
      this.$store.dispatch('search/resetState')
      this.$router.push('/')
    },
    goToRegister () {
      this.$router.push('/register')
    },
  },
  mounted () {
    if (this.isAuthenticated) {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.login {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  min-height: 100vh;

  @media screen and (min-width: $breakpointMd) {
    flex-direction: row;
  }

  h1 {
    @include font('header--xl', $white, 0.9);
    width: 90%;
    margin: 0 auto;
    text-align: center;

    @media screen and (min-width: $breakpointLg) {
      @include font('header--xxl', $white, 0.9);
      margin: 0 auto;
    }
  }

  h2 {
    @include font('header--md', $black, 0.6);
    width: 90%;
    margin: 0 auto;
    text-align: center;
    font-weight: 500;
  }

  p {
    @include font('header--sm', $black, 0.6);
    width: 90%;
    margin: 0 auto;
    text-align: center;
    font-weight: 500;
  }

  &__logo {
    @media screen and (min-width: $breakpointMd) {
      width: 166px;
      height: 26px;
      background-image: url('/img/statzon_logo_white_animated.svg');
      background-size: contain;
      background-repeat: no-repeat;
      margin: 0 auto 4rem auto;
      background-position: 0px 0px;
    }
  }

  &__left {
    position: relative;
    z-index: 10;
    display: flex;
    justify-content: center;
    flex-direction: column;
    flex: 0.7;
    background-color: $bg-4;
    background-image: url('/img/pattern_navy.png');
    background-position: 0 0;
    background-repeat: repeat;
    padding-top: 1vh;
    padding-bottom: 5vh;

    @media screen and (min-width: $breakpointMd) {
      flex: 0.58;
      padding-bottom: 15vh;
    }

    @media screen and (min-width: $breakpointLg) {
      flex: 0.62
    }
  }

  &__right {
    background-color: $bg-4;
    background-image: url('/img/pattern_navy.png');
    background-position: 0 0;
    background-repeat: repeat;
    position: relative;
    z-index: 5;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    flex: 0.3;

    @media screen and (min-width: $breakpointMd) {
      flex: 0.42;
      padding-bottom: 6rem;
      justify-content: center;

      &:before {
        content: ' ';
        border-top: 70vh solid $bg-5;
        border-right: 150vw solid transparent;
        width: 0;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
      }

      &:after {
        content: ' ';
        border-bottom: 70vh solid $bg-5;
        border-left: 150vw solid transparent;
        width: 0;
        position: absolute;
        bottom: 25vh;
        left: 0;
        z-index: -1;
      }
    }

    @media screen and (min-width: $breakpointLg) {
      flex: 0.38;
      padding-bottom: 8rem;

      &:before {
        border-top: 70vh solid $bg-5;
        border-right: 120vw solid transparent;
      }

      &:after {
        border-bottom: 70vh solid $bg-5;
        border-left: 120vw solid transparent;
      }
    }

    /*&--top {
      margin-top: 4rem;

      @media screen and (min-width: $breakpointMd) {
        margin-top: 7.5vh;
      }
    }*/
  }

  &__form {
    width: 90%;
    max-width: 460px;
    margin: 0 auto;
  }

  &__registerBtn {
    margin: 2rem auto 4rem auto;
  }

  &__close {
    position: fixed;
    top: 8px;
    right: 16px;
    z-index: 99;
  }

  &__buffer {
    position: absolute;
    z-index: -1;
    bottom: 0;
    right: 0;
    width: 100%;
    margin: 0 auto;
    min-height: 240px;
    height: auto;
    padding: 1.5rem 0;
    background-color: $bg-5;

    @media screen and (min-width: $breakpointMd) {
      min-height: auto;
      height: 25vh;
      padding: 0;
    }
  }
}

.spacer {
  width: 36px;
  height: 5px;
  background-color: rgba($bg-4, 0.6);
  margin: 0.5rem auto 0.75rem auto;
  border-radius: 999px;
}

</style>
